import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import * as PermisoService from '../../axios_services/permisosalida.service';

const ModalAprobarTHPermiso = ({ isOpen, onClose, permiso, onRefresh }) => {
    const [fechaRegreso, setFechaRegreso] = useState('');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (isOpen && permiso) {
            setFechaRegreso(permiso.fecha_regreso || permiso.fecha_salida || '');
        }
    }, [isOpen, permiso?.permiso_id]);

    const handleAprobar = async () => {
        if (!window.confirm('¿Confirma la aprobación final de este permiso?')) return;
        setSaving(true);
        try {
            await PermisoService.aprobarTH({
                permiso_id:   permiso.permiso_id,
                observaciones: '',
                fecha_regreso: fechaRegreso || null,
            });
            onRefresh();
            onClose();
        } catch (err) {
            alert(err.response?.data?.error || 'Error al aprobar.');
        } finally {
            setSaving(false);
        }
    };

    if (!permiso) return null;

    return (
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static">
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>APROBAR PERMISO (ADMINISTRACIÓN)</h1>
                    <Button className="close-btn" onClick={onClose}>X</Button>
                </div>
            </ModalHeader>

            <div className="modal-body-footer">
                <ModalBody className="modal-body">
                    <Form className="fila" onSubmit={e => e.preventDefault()}>

                        <FormGroup>
                            <Label>Colaborador:</Label>
                            <Input
                                type="text"
                                value={permiso.nombre_empleado || ''}
                                readOnly
                                style={{ background: '#f3f4f6', cursor: 'default' }}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Motivo:</Label>
                            <Input
                                type="text"
                                value={permiso.motivo || ''}
                                readOnly
                                style={{ background: '#f3f4f6', cursor: 'default' }}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Fecha de Salida:</Label>
                            <Input
                                type="text"
                                value={permiso.fecha_salida || ''}
                                readOnly
                                style={{ background: '#f3f4f6', cursor: 'default' }}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Fecha de regreso:</Label>
                            <Input
                                type="date"
                                value={fechaRegreso}
                                onChange={e => setFechaRegreso(e.target.value)}
                                min={permiso.fecha_salida}
                                style={{ width: '100%' }}
                            />
                        </FormGroup>

                        <FormGroup style={{ marginTop: '18px', gridColumn: '1 / -1' }}>
                            <div className="button-container">
                                <Button
                                    className="button-custom"
                                    onClick={handleAprobar}
                                    disabled={saving}
                                >
                                    {saving ? 'REGISTRANDO...' : 'REGISTRAR'}
                                </Button>
                            </div>
                        </FormGroup>

                    </Form>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalAprobarTHPermiso;
